import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'billing/';

class BillingService {
    getClientsBillings() {
        return axios.get(API_URL + 'getclientbillings', { headers: authHeader() });
    }

    getByMonth(month) {
        return axios.get(API_URL + 'getByMonth/' + month, { headers: authHeader() });
    }

    getClientDetailsByMonth(clientId, month) {
        return axios.get(API_URL + 'client/' + clientId + '/' + month, {
            headers: authHeader()
        });
    }

    getRevenueProgress(start, end) {
        return axios.get(API_URL + 'revenue-progress', {
            headers: authHeader(),
            params: {
                start,
                end
            }
        });
    }

    getMonthlyPdfReport(month) {
        return axios.get(API_URL + 'report/' + month, {
            headers: authHeader()
        });
    }
}

export default new BillingService();